import { Box, FormControl } from '@mui/material'
import React, { useRef, useState } from 'react'
import {
  Button,
  Input,
  Dropdown,
  Typography,
  Checkbox
} from '@evocolabs/orkaui'
import i18n from 'i18next'
import k from './../../i18n/keys'
import { useBackend } from '@/src/providers/BackendProvider'
import { statesChoice } from 'src/components/Checkout/Delivery/State.js'

const Profile = ({ signUpEmail }) => {
  const { signedin, emailSubscribe } = useBackend()
  const [p2Values, setP2Values] = useState({
    firstName: i18n.t(k._),
    lastName: i18n.t(k._),
    date: i18n.t(k._),
    year: '2020',
    gender: i18n.t(k._),
    state: i18n.t(k._),
    checked: false
  })

  const [errors, setErrors] = useState({
    firstName: i18n.t(k._),
    lastName: i18n.t(k._),
    date: i18n.t(k._),
    gender: i18n.t(k._),
    state: i18n.t(k._),
    checked: false
  })

  const checkInfo = () => {
    return (
      p2Values.firstName !== '' &&
      p2Values.lastName !== '' &&
      p2Values.gender !== '' &&
      p2Values.state !== '' &&
      errors.firstName === '' &&
      errors.lastName === '' &&
      errors.gender === '' &&
      errors.state === ''
    )
  }

  const handleGender = (e) => {
    console.log(e.target.value)
    setP2Values({ ...p2Values, gender: e.target.value })
    setErrors((latestErrors) => {
      return { ...latestErrors, gender: i18n.t(k._) }
    })
  }

  const registerButtonRef = useRef(null)
  const { patchUser } = useBackend()

  const handleCheckout = async () => {
    if (checkInfo) {
      if (p2Values.firstName === '') {
        setErrors((latestErrors) => {
          return {
            ...latestErrors,
            firstName: i18n.t(k.FIRST_NAME_REQUIRED_FIELD)
          }
        })
        throw new Error('Invalid')
      }
      if (p2Values.lastName === '') {
        setErrors((latestErrors) => {
          return {
            ...latestErrors,
            lastName: i18n.t(k.LAST_NAME_REQUIRED_FIELD)
          }
        })
        throw new Error('Invalid')
      }
      if (p2Values.date === '') {
        setErrors((latestErrors) => {
          return {
            ...latestErrors,
            date: i18n.t(k.DATE_INFORMATION_REQUIRED_FIE)
          }
        })
        throw new Error('Invalid')
      }
      if (p2Values.gender === '') {
        setErrors((latestErrors) => {
          return {
            ...latestErrors,
            gender: i18n.t(k.GENDER_INFORMATION_REQUIRED_F)
          }
        })
        throw new Error('Invalid')
      }
      if (p2Values.state === '') {
        setErrors((latestErrors) => {
          return {
            ...latestErrors,
            state: i18n.t(k.RESIDENCY_INFORMATION_REQUIRE)
          }
        })
        throw new Error('Invalid')
      }
    }
    if (p2Values) {
      const data = {
        email: signUpEmail,
        page: 'SignIn'
      }

      await emailSubscribe(data)
    }
    if (checkInfo) {
      const res = await patchUser({
        first_name: p2Values.firstName,
        last_name: p2Values.lastName,
        birth_year: p2Values.date,
        gender: p2Values.gender,
        state: p2Values.state
      })
      if (signedin) {
        window.location.href = '/Account'
      } else {
        window.location.href = '/SignIn'
      }
      return res
    } else {
      throw new Error('Invalid')
    }
  }
  const handleChange2 = (prop) => (event) => {
    setP2Values({
      ...p2Values,
      [prop]: event.target.value
    })

    if (prop === 'lastName' && event.target.value !== '') {
      setErrors({ ...errors, lastName: i18n.t(k._) })
    } else if (prop === 'firstName' && event.target.value !== '') {
      setErrors({ ...errors, firstName: i18n.t(k._) })
    } else if (prop === 'date' && event.target !== '') {
      setErrors({ ...errors, date: i18n.t(k._) })
    } else if (prop === 'gender' && event.target.value !== '') {
      setErrors({ ...errors, gender: i18n.t(k._) })
    } else if (prop === 'state' && event.target.value !== '') {
      setErrors({ ...errors, state: i18n.t(k._) })
    } else if (prop === 'checked' && event.target.value === true) {
      setErrors({ ...errors, checked: i18n.t(k._) })
    }
  }

  const handleSkip = () => {
    if (signedin) {
      window.location.href = '/Account'
    } else {
      window.location.href = '/SignIn'
    }
  }

  const handleChecked = (event) => {
    setP2Values({ ...p2Values, [event.target.name]: event.target.checked })
  }

  const years = []
  const currentYear = new Date().getFullYear()
  for (let i = 1920; i <= currentYear; i++) {
    years.push(i.toString())
  }

  return (
    <Box display={'flex'} gap={4} flexDirection={'column'}>
      <Typography variant="h4">
        {i18n.t(k.LET_US_KNOW_MORE_ABOUT_YOU)}
      </Typography>
      <Box display={'flex'} gap={2} flexDirection={'column'}>
        <FormControl>
          <Input
            id="outlined-adornment-firstName"
            placeholder="First Name"
            required
            type="text"
            value={p2Values.firstName}
            onChange={handleChange2('firstName')}
            errormsg={errors.firstName}
            fullWidth
          />
        </FormControl>
        <FormControl>
          <Input
            id="outlined-adornment-lastName"
            placeholder="Last Name"
            required
            type="text"
            value={p2Values.lastName}
            onChange={handleChange2('lastName')}
            errormsg={errors.lastName}
            fullWidth
          />
        </FormControl>
        <FormControl variant="standard">
          <Dropdown
            id="outlined-adornment-year"
            name="year"
            label="Year"
            placeholder="Year of Birth"
            value={p2Values.date}
            onChange={handleChange2('date')}
            choice={years}
            errormsg={errors.date}
          />
        </FormControl>
        <FormControl variant="standard">
          <Dropdown
            id="outlined-adornment-gender"
            name="gender"
            label="Gender"
            placeholder="Gender"
            value={p2Values.gender}
            onChange={handleGender}
            choice={['Male', 'Female', 'Others']}
            errormsg={errors.gender}
          />
          <Typography variant="body4" mt={1}>
            {i18n.t(k.REFERENCE_INFORMATION_REQUIRED)}
          </Typography>
        </FormControl>
        <FormControl>
          <Dropdown
            id="State"
            name="State"
            label="State"
            placeholder="State"
            value={p2Values.state}
            onChange={handleChange2('state')}
            choice={statesChoice}
            errormsg={errors.state}
          />
        </FormControl>
        <FormControl>
          <Checkbox
            checked={p2Values.checked}
            onChange={handleChecked}
            name="checked"
            label={i18n.t(k.SUBSCRIBE_TO_STAY_UPDATE_WITH)}
          />
        </FormControl>
      </Box>

      <Box
        display={'flex'}
        flexDirection={'column'}
        gap={2}
        alignItems={'center'}
      >
        <Button
          color="primary"
          variant="contained"
          size="large"
          loadable
          handleClick={handleCheckout}
          width="184px"
        >
          {i18n.t(k.SUBMIT)}
        </Button>
        <Button variant="textprimary" onClick={handleSkip}>
          Skip
        </Button>
      </Box>
    </Box>
  )
}

export default Profile
